import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ins-schadenummer',
    template: `
        <span>{{ schadenummer }}</span>
    `,
})
export class SchadenummerComponent implements OnInit {

    @Input() relatie_id: string;
    @Input() dossier_volgnummer: string;

    public schadenummer: string = '';

    ngOnInit(): void {
        const _organisatie_id = 'INSH';
        const _relatie_id = (`0000000${this.relatie_id}`).slice(-7);
        const _dossier_volgnummer = (`000${this.dossier_volgnummer}`).slice(-3);

        if ( this.relatie_id && this.dossier_volgnummer ) {
            this.schadenummer =  `${_organisatie_id}.${_relatie_id}.${_dossier_volgnummer}`;
        } else {
            this.schadenummer = '';
        }
    }
}
